import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public apiUrl = "http://howadmin.postgresconf.cn/";
  constructor() { }

}
